// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dcN5","clinicsSelect":"styles_clinicsSelect__2HrhO"};